import axios from "axios";
import toast from "react-hot-toast";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Action Types
export const FETCH_CHALLANS_REQUEST = "FETCH_CHALLANS_REQUEST";
export const FETCH_CHALLANS_SUCCESS = "FETCH_CHALLANS_SUCCESS";
export const FETCH_CHALLANS_FAILURE = "FETCH_CHALLANS_FAILURE";

export const fetchChallans =
  (page = 1, limit = 10, filters = {}) =>
  async (dispatch) => {
    dispatch({ type: FETCH_CHALLANS_REQUEST });
    const token = localStorage.getItem("token");

    try {
      let queryParams = `?page=${page}&limit=${limit}`;
      if (filters.district_id)
        queryParams += `&district_id=${filters.district_id}`;
      if (filters.municipality_id)
        queryParams += `&municipality_id=${filters.municipality_id}`;
      if (filters.search)
        queryParams += `&search=${encodeURIComponent(filters.search)}`;
      if (filters.payment_status)
        queryParams += `&payment_status=${filters.payment_status}`;
      if (filters.offense_id)
        queryParams += `&offense_id=${filters.offense_id}`;
      if (filters.start_date)
        queryParams += `&start_date=${filters.start_date}`;
      if (filters.end_date) queryParams += `&end_date=${filters.end_date}`;

      const response = await axios.get(
        `${BASE_URL}/v1/api/admin/challans${queryParams}`,
        { headers: { authorization: token } },
      );

      if (response.data.meta.status) {
        dispatch({
          type: FETCH_CHALLANS_SUCCESS,
          payload: {
            data: response.data.data.rows || [],
            pagination:
              response.data.data.pagination || response.data.meta.pagination,
          },
        });
        return response.data;
      } else {
        dispatch({ type: FETCH_CHALLANS_FAILURE });
        throw new Error(response.data.meta.message);
      }
    } catch (error) {
      dispatch({ type: FETCH_CHALLANS_FAILURE });
      toast.error(
        error.response?.data?.meta?.message || "Failed to fetch challans",
      );
      throw error;
    }
  };

// For bulk export
export const fetchAllChallans = async (filters = {}, limit = 200000) => {
  const token = localStorage.getItem("token");

  let queryParams = `?page=1&limit=${limit}`;
  if (filters.district_id) queryParams += `&district_id=${filters.district_id}`;
  if (filters.municipality_id)
    queryParams += `&municipality_id=${filters.municipality_id}`;
  if (filters.search)
    queryParams += `&search=${encodeURIComponent(filters.search)}`;
  if (filters.payment_status)
    queryParams += `&payment_status=${filters.payment_status}`;
  if (filters.offense_id) queryParams += `&offense_id=${filters.offense_id}`;
  if (filters.start_date) queryParams += `&start_date=${filters.start_date}`;
  if (filters.end_date) queryParams += `&end_date=${filters.end_date}`;

  const response = await axios.get(
    `${BASE_URL}/v1/api/admin/challans${queryParams}`,
    { headers: { authorization: token } },
  );

  return response.data.data.rows || [];
};

export const cancelChallan = (challanId, remarks) => async (dispatch) => {
  const token = localStorage.getItem("token");

  try {
    const response = await axios.put(
      `${BASE_URL}/v1/api/admin/challans/${challanId}/cancel`,
      { cancelled_remarks: remarks },
      { headers: { authorization: token } },
    );

    if (response.data.meta.status) {
      toast.success(
        response.data.meta.message || "Challan cancelled successfully!",
      );
      return response.data;
    } else {
      toast.error(response.data.meta.message || "Failed to cancel challan");
      throw new Error(response.data.meta.message);
    }
  } catch (error) {
    toast.error(
      error.response?.data?.meta?.message || "Failed to cancel challan",
    );
    throw error;
  }
};
